import { ReactElement, Fragment } from 'react';
import SetPassword from './login/SetPassword';
import TermsAndPolicy from './login/TermsAndPolicy';

interface Props {
  requestAccess: string[];
}

const RequiresPermission = ({ requestAccess }: Props): ReactElement => {
  switch (requestAccess[0]) {
    case 'termos':
      return <TermsAndPolicy />;

    case 'resetPassword':
      return <SetPassword />;

    default:
      return <>fim</>;
  }
};

export default RequiresPermission;
